"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertColumns = exports.insertColumn = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var isNil_1 = __importDefault(require("lodash/isNil"));
function insertColumn(currentColumns, columnDefinition, position) {
    if ((0, isNil_1.default)(position)) {
        return currentColumns.concat(columnDefinition);
    }
    return __spreadArray(__spreadArray(__spreadArray([], currentColumns.slice(0, position), true), [columnDefinition], false), currentColumns.slice(position), true);
}
exports.insertColumn = insertColumn;
function insertColumns(currentColumns, additionalColumns) {
    var columns = currentColumns;
    additionalColumns.forEach(function (additionalColumn) {
        columns = insertColumn(columns, additionalColumn.column, additionalColumn.position);
    });
    return columns;
}
exports.insertColumns = insertColumns;
